import { Header } from "../components/Header";
import { Text } from "../components/Text";
import { Box } from "../components/Box";
import { Button } from "../components/Button";
import { useState } from "react";
import QRCode from "react-qr-code";
import { useParams } from 'react-router-dom'
import { config } from "../config";

export function NewPatientFormLink() {
  const params = useParams()
  const [hasCopied, setHasCopied] = useState(false)

  const formId = params.formId;
  const link = `${config.frontEndUrl}/Forms/NewPatientForm/${formId}`

  async function copyLink() {
    await navigator.clipboard.writeText(link);
    setHasCopied(true)
    setTimeout(() => {
      setHasCopied(false)
    }, 2000);
  }

  return (
    <>
      <Header />
      <Box 
        alignHorizontal="center" 
        alignVertical="center" 
        direction="vertical"
        paddingTopCode="xl"
      >

        <Box paddingTopCode="xl" />

        <Text size="xxl" weight="strong">
          Patient Link
        </Text>

        <Box paddingTopCode="md" />

        <Text size="md" color="grey" align="center">
          Send the link to the patient or scan the QR code below<br/> on a device to fill out the new patient forms
        </Text>

        <Box paddingTopCode="xxl" />

        <QRCode
          size={180}
          value={link}
          viewBox={`0 0 150 150`}
        />

        <Box paddingTopCode="xxl" />

        <Button onClick={copyLink} label={hasCopied ? 'Copied!' : 'Copy Link'} />

        <Box paddingTopCode="md" />

          <Text size="sm" color="grey">
            {link}
          </Text>
      </Box>
    </>
  )
}